import { BillyWelcomeModal } from '@components'

import { byAttrVal, createCustomElement, DOMModel } from '@adobe/react-webcomponent'
import { ModalContextProvider } from '@billy/design-system'
import React, { ReactElement } from 'react'

import { SubscriptionPlan } from '@modules-deprecated/app/organization/enums/subscriptionPlan'

import { ThemeProvider } from '../../contexts/themeProvider'

class BillyWelcomeModalWebComponent extends DOMModel {
  @byAttrVal plan: string
}

interface BillyWelcomeModalProps {
  plan: SubscriptionPlan.Basic | SubscriptionPlan.Pro | SubscriptionPlan.Premium
}

function BillyWelcomeModalModule({ plan }: BillyWelcomeModalProps): ReactElement {
  return (
    <ThemeProvider>
      <ModalContextProvider>
        <BillyWelcomeModal plan={plan} />
      </ModalContextProvider>
    </ThemeProvider>
  )
}

const BillyWelcomeModalCustomElement = createCustomElement(
  BillyWelcomeModalModule,
  BillyWelcomeModalWebComponent,
  'element',
)

customElements.get('billy-welcome-modal-module') ||
  customElements.define('billy-welcome-modal-module', BillyWelcomeModalCustomElement)

export default BillyWelcomeModalCustomElement
